import React from 'react';
import styled from 'styled-components';
import { InputAdornment, TextField } from '@mui/material';
import theme from '../theme';
import Typo from '../Typo';
import { Flex } from '..';

const TextFieldStyled = styled(TextField)`
  width: ${(props) => (props.width && props.width) || '100%'};
  max-width: ${(props) => props.$maxwidth};
  && p, input, textarea, label {
    font-family: ${theme.fonts.TEXT_FONT}, sans-serif !important;
    color: ${theme.colors.NEUTRAL_PRIMARY};
    font-weight: 300;
  }
  && input, textarea {
    line-height: 24px;
    font-size: ${theme.fontSizes.regular};
  }
  && label {
    font-size: ${theme.fontSizes.medium};
  }

  .MuiInputBase-root {
    background-color: white;
    padding:  ${({ $pillShape }) => $pillShape ? '8px 8px 8px 16px' : '0 8px'};
    border-radius: ${({ $pillShape }) => $pillShape && '16px'};
  }

  &.MuiFormControl-root {
    margin: ${({ flat }) => !flat && '0.5rem 0 0.5rem'};
  }
`;

const Textinput = ({
  onBlurValue,
  propName,
  isMultiline,
  innerRef,
  flatStyle,
  label,
  pillShape,
  startIcon,
  endIcon,
  minRows,
  maxRows,
  ...props
}) => {
  const componentProps = {
    inputRef: innerRef,
    variant: 'outlined',
    size: 'small',
    multiline: isMultiline,
    $pillShape: pillShape,
    minRows: isMultiline ? minRows || 1 : undefined, // Apply minRows for multiline
    maxRows: isMultiline ? maxRows || 8 : undefined, // Apply maxRows for multiline
    onBlur: (el) => onBlurValue && onBlurValue(el),
    InputLabelProps: {
      shrink: true,
    },
    flat: flatStyle,
    InputProps: {
      ...props?.InputProps,
      startAdornment: startIcon && (
        <InputAdornment position="start">{startIcon}</InputAdornment>
      ),
      endAdornment: endIcon && (
        <InputAdornment position="end">{endIcon}</InputAdornment>
      ),
    },
    inputProps: {
      ...props?.InputProps?.inputProps,
      'data-propname': propName,
    },
  };

  return label ? (
    <Flex direction="column" align="flex-start" width="100%">
      <Typo.SmallText>{label}</Typo.SmallText>
      <TextFieldStyled {...componentProps} {...props} />
    </Flex>
  ) : (
    <TextFieldStyled {...componentProps} {...props} />
  );
};

export default Textinput;
